<!-- src/components/Activity/MyActivitiesToggle.vue -->
<script setup>
import { computed } from "vue";
import { useActivityStore } from "@/stores/useActivityStore";

const activityStore = useActivityStore();

const isActive = computed(() => activityStore.myActivitiesOnly);

function toggleMyActivities() {
  const newValue = !activityStore.myActivitiesOnly;
  activityStore.setMyActivitiesOnly(newValue);

  activityStore.searchTerm = "";

  activityStore.fetchActivitiesPaged(
    1,
    activityStore.pageSize,
    activityStore.searchTerm,
    activityStore.currentTextId
  );
}
</script>

<template>
  <button
    type="button"
    class="btn-filter"
    :class="{ active: isActive }"
    @click="toggleMyActivities"
    title="Filtrar apenas minhas atividades"
  >
    <i class="fas fa-user"></i>
    <span>Minhas Atividades</span>
  </button>
</template>

<style scoped>
.btn-filter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 0.8rem;
  font-size: 0.85rem;
  border-radius: 10px;
  border: 1px solid var(--border-color);
  background-color: var(--neutral-200);
  color: var(--text-dark);
  cursor: pointer;
  transition: background-color 0.2s ease-in-out, transform 0.05s ease;
  white-space: nowrap;
  gap: 0.35rem;
}
.btn-filter:hover {
  background-color: var(--neutral-300);
}
.btn-filter:focus,
.btn-filter:focus-visible {
  outline: none;
  box-shadow: none;
}
.btn-filter:active {
  transform: translateY(1px);
}
.btn-filter.active {
  background-color: var(--brand-light);
  border-color: var(--brand-light);
  color: var(--text-on-brand);
}
.btn-filter.active:hover {
  background-color: var(--brand-light-hover);
}
.btn-filter.active:active {
  transform: translateY(1px);
}
.btn-filter i {
  font-size: 0.85rem;
}
</style>